<template>
  <button
    @click="handleClick"
    @mousedown="isPressed = true"
    @mouseleave="isPressed = false"
    @mouseup="isPressed = false"
    class="video-button"
    :class="{ 'video-button--pressed': isPressed }"
  >
    <span class="video-button__title title">
      <span class="title__before">Become a Customizer Pro</span>
      <span class="title__after">Watch our design tutorial</span>
    </span>
    <span class="video-button__icon-wrapper">
      <span class="video-button__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path 
            d="M19.0367 7.58193C21.8322 9.02675 23.23 9.74916 23.6956 10.6984C24.1015 11.5261 24.1015 12.4739 23.6956 13.3016C23.23 14.2508 21.8322 14.9732 19.0367 16.4181L8.22181 22.0075C5.51909 23.4043 4.16773 24.1027 3.06082 23.9878C2.09512 23.8875 1.22033 23.4174 0.651737 22.6932C0 21.8632 0 20.4386 0 17.5894V6.41059C0 3.56141 0 2.13683 0.651737 1.30677C1.22033 0.582609 2.09512 0.112531 3.06082 0.0122289C4.16773 -0.102741 5.51909 0.595678 8.22181 1.99252L19.0367 7.58193Z" 
            fill="white"
          />
        </svg>
      </span>
    </span>
  </button>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import pinia from '../../core/pinia';
import { useModalStore } from '../../stores';
import { E_MODAL } from '../../types/modals.enum';

const modalStore = useModalStore(pinia);

const isPressed = ref(false);

function handleClick() {
  const modalIds = modalStore.getModalIdsByName(E_MODAL.GUIDE_MODAL);
  if (!modalIds.length) {
    throw new Error(`Modal '${E_MODAL.GUIDE_MODAL}' not found'`);
  }
  modalStore.show(modalIds[0]);
}
</script>

<style scoped lang="scss">
.video-button {
  display: flex;
  flex-direction: row;
  background: none;
  border: 1px solid $brand-color;
  width: 100%;
  cursor: pointer;
  padding: 0;
  transition: 
    transform 0.2s ease-out,
    border-color 0.3s ease,
    background-color 0.3s ease;
  will-change: transform;

  .title__before { transition: color 0.2s ease; }
  .title__after { transition: color 0.2s ease; }
  &__icon-wrapper { 
    transition: background-color 0.3s ease, transform 0.2s ease-out; 
  }

  &:hover {
    border-color: $brand-color;
    .title__before { color: #1a1a1a; }
    .title__after { color: #000; }
  }

  &--pressed,
  &:active {
    transform: scale(0.98);
    border-color: $brand-color;
    &__icon-wrapper {
      background: $brand-color;
      transform: scale(0.95);
    }
  }

  &:focus-visible {
    outline: 2px solid $brand-color;
    outline-offset: 2px;
  }

  &__icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 40px;
    height: 100%;
    max-height: 40px;
    background: $brand-color;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 13px;
    height: 13px;
  }
}

.title {
  display: flex;
  flex-direction: column;
  padding: 3px;
  font-variant-numeric: lining-nums proportional-nums;
  text-align: center;
  font-style: normal;
  color: #282828;
  width: 100%;
  
  &__before {
    font-family: "Montserrat";
    font-size: 9px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0.34px;
    text-transform: capitalize;
  }

  &__after {
    font-family: "Bebas Neue";
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.32px;
    text-transform: uppercase;
  }
}
</style>